'use strict';

var chunkC7C34JBA_js = require('./chunk-C7C34JBA.js');
var e = require('react');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var e__default = /*#__PURE__*/_interopDefault(e);

var s=({data:r,onClickCallback:a,lazyLoadImage:o})=>{let{data:i=[]}=r||{},d=n=>{switch(n){case"Play Store":return "google play";case"App Store":return "app store";default:return ""}};return e__default.default.createElement(chunkC7C34JBA_js.k,null,i.map(n=>e__default.default.createElement("a",{key:n.name,href:n.url,onClick:()=>a(d(n.name))},e__default.default.createElement("img",{loading:o?"lazy":"eager",src:n.image,alt:n.alt,width:"160px",height:"47px"}))))};

exports.a = s;
